import React, { useState } from 'react';
import './Contact.css';
import { saveInquiry } from '../services/inquiries';

const INITIAL_FORM = {
  name: '',
  email: '',
  company: '',
  type: 'general',
  message: '',
};

const Contact = () => {
  const [formData, setFormData] = useState(INITIAL_FORM);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: '', message: '' });

    const payload = {
      ...formData,
      name: formData.name.trim(),
      email: formData.email.trim(),
      company: formData.company.trim(),
      message: formData.message.trim(),
    };

    try {
      const saveResult = await saveInquiry(payload);
      if (saveResult && saveResult.saved) {
        setSubmitStatus({
          type: 'success',
          message: 'Inquiry submitted successfully. Our team will contact you shortly.',
        });
        setFormData(INITIAL_FORM);
      } else {
        setSubmitStatus({
          type: 'error',
          message: 'Unable to submit your inquiry right now. Please email info@mojexpress.com.',
        });
      }
    } catch (error) {
      setSubmitStatus({
        type: 'error',
        message:
          'Unable to submit your inquiry right now. Please email info@mojexpress.com.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="container">
          <h1>Get in Touch</h1>
          <p>We're here to help. Reach out for support, partnerships, or corporate inquiries.</p>
        </div>
      </section>

      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>Contact Information</h2>

              <div className="info-item">
                <h3>Email</h3>
                <p>Contact: info@mojexpress.com</p>
                <p>Financials: accounts@mojexpress.com</p>
              </div>

              <div className="info-item">
                <h3>Phone</h3>
                <p>+923217946427</p>
                <p>Mon-Sun, 24/7</p>
              </div>

              <div className="info-item">
                <h3>Office</h3>
                <p>Islamabad, Pakistan</p>
                <p>Open 24/7 (Mon-Sun)</p>
              </div>

              <div className="corporate-cta">
                <h3>Corporate Inquiries?</h3>
                <p>
                  Looking for business transportation solutions? Our team is ready to customize
                  a plan for your company.
                </p>
              </div>
            </div>

            <div className="contact-form-container">
              <form className="contact-form" onSubmit={handleSubmit}>
                <h2>Send us a Message</h2>

                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Your name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your@email.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="company">Company (Optional)</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    placeholder="Company name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="type">Inquiry Type</label>
                  <select
                    id="type"
                    name="type"
                    value={formData.type}
                    onChange={handleChange}
                  >
                    <option value="general">General Inquiry</option>
                    <option value="corporate">Corporate Partnership</option>
                    <option value="support">Customer Support</option>
                    <option value="driver">Become a Driver</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    placeholder="How can we help you?"
                  ></textarea>
                </div>

                {submitStatus.message ? (
                  <p className={`form-status ${submitStatus.type}`}>{submitStatus.message}</p>
                ) : null}

                <button
                  type="submit"
                  className="btn-primary"
                  style={{ width: '100%' }}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
